import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadge } from '@angular/material/badge';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { Subscription, firstValueFrom } from 'rxjs';
import { FieldService } from '../../features/field/field.service';
import { Autocomplete } from '../../models/autocomplete';
import { Field } from '../../models/field';
import { Folder } from '../../models/folder';
import { FolderService } from '../../services/folder/folder.service';
import { AutocompletePickerModule } from '../autocomplete-picker/autocomplete-picker.module';
import { ColorPickerModule } from '../color-picker/color-picker.module';
import { TranslateModule } from '../translate/translate.module';

@Component({
  selector: 'apex-select-field',
  templateUrl: './select-field.component.html',
  standalone: true,
  imports: [
    CommonModule,
    AutocompletePickerModule,
    TranslateModule,
    ColorPickerModule,
    FormsModule,
    MatMenu,
    MatMenuContent,
    MatMenuItem,
    MatIconButton,
    MatMenuTrigger,
    MatBadge,
    MatIcon,
    MatButton,
  ],
  providers: [FieldService, FolderService],
})
export class SelectFieldComponent implements OnDestroy, OnChanges {
  @Input() folder: Folder;
  @Input() parentFolder: Folder;
  @Output() fieldId: EventEmitter<number> = new EventEmitter<number>();

  fields: Field[];
  field;

  private sub$$ = new Subscription();

  constructor(private fieldService: FieldService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['parentFolder'] && changes['parentFolder'].currentValue) {
      if (this.parentFolder.modelId) {
        this.fields = await firstValueFrom(this.fieldService.getObjectFields(Number(this.parentFolder.modelId)));

        if (this.folder.FieldId) {
          this.field = this.fields.find(
            (f) => f.id === this.folder.FieldId || f.ProjectField.FieldId === this.folder.FieldId,
          );
        }
      }
    }

    if (changes['folder'] && changes['folder'].currentValue) {
      if (this.fields) {
        if (this.folder.FieldId) {
          this.field = this.fields.find(
            (f) => f.id === this.folder.FieldId || f.ProjectField.FieldId === this.folder.FieldId,
          );
        }
      }
    }
  }

  async updateField(event?: Autocomplete): Promise<void> {
    this.field = this.fields?.find((field) => field.id === event?.id);
    this.fieldId.emit(this.field?.id);
  }

  remove(): void {
    this.field = null;
    this.fieldId.emit(null);
  }

  ngOnDestroy(): void {
    this.sub$$.unsubscribe();
  }

  convertToNumber(): number {
    return Number(this.parentFolder?.modelId);
  }
}
